import classNames from "classnames";

export const Form = ({ children, handleSubmit, className }) => {
    const cn = classNames(className);

    return (
        <form onSubmit={handleSubmit} className={cn}>
            {children}
        </form>
    );
};
